<template>
  <section>
    <div class="sp-title">其他费用台账</div>
    <div class="sp-nav"><span class="sp-nav-item">商务管理</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">其他费用台账</span></div>
    <el-form>
    <div class="input-box2" >
      <div class="date-box" >
        <div class="font2" >离港时间</div>
        <el-date-picker class="date"
                        v-model="value1"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="botton-box" style="width: 100px" >
      <el-form-item class="botton1" style="margin-left: 30px" >
        <el-button @click="getTableData(1)" type="primary" >查询</el-button>
      </el-form-item>
    </div>
      <div class="botton-box" style="width: 200px" v-if="queryParams.pageSize === 5000" >
        <el-form-item class="botton1" >
          <el-button  @click="returnPageSie" type="primary" >分页展示</el-button>
        </el-form-item>
      </div>
      <div class="botton-box" style="width: 200px" v-if="queryParams.pageSize === 20" >
        <el-form-item class="botton1" >
          <el-button  @click="updatePageSie" type="primary" >展示全部（导出用）</el-button>
        </el-form-item>
      </div>
    </div>
    </el-form>
    <vxe-toolbar
      export
      custom
      print
      ref="xToolbar"
      :buttons="toolbarButtons"
    >
    </vxe-toolbar>
      <vxe-table
        :data="tableData"
        stripe
        size="small"
        ref="xTable"
        border
        class="mytable-scrollbar myvxetable"
        align="center"
        :print-config="{}"
        max-height="800"
        highlight-current-row
        :export-config="{'type':'xlsx', 'sheetName':'sheet1', 'filename': '其他费用台账', 'isColgroup': true, 'isMerge': true, 'useStyle': true}"
        resizable
      >
        <vxe-table-column  field="epartureTimeDate"
                          :formatter="({row, column, cellValue, index}) => { return myFmtDateTime(cellValue,'MM/DD')}"
                          title="离港日期" width="80" ></vxe-table-column>
        <vxe-table-column  field="onAccountNum" :formatter="publicFmt" title="挂账号" width="120" ></vxe-table-column>
        <vxe-table-column  field="shipName" :formatter="publicFmt" title="船名" width="100"></vxe-table-column>
        <vxe-table-column  field="yewuUserName" :formatter="publicFmt" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column  field="loadWharfName" :formatter ="publicFmt" title="装货码头" width="80" ></vxe-table-column>
        <vxe-table-column  field="finalWharfName" :formatter="publicFmt" title="卸货码头" width="80" ></vxe-table-column>
        <vxe-table-column  field="costType" :formatter="other_incomeFmt" title="费用科目" width="80" ></vxe-table-column>
        <vxe-table-column  field="tonnage" :formatter="publicFmtnumber3" title="重量" width="100"></vxe-table-column>
        <vxe-table-column  field="customerName" :formatter="publicFmt" title="客户名称" width="100"></vxe-table-column>
        <vxe-table-column  field="costType" :formatter="other_incomeFmt" title="费用科目" width="80" ></vxe-table-column>
        <vxe-table-column  field="money" :formatter="publicFmtnumber2" title="运价" width="80"></vxe-table-column>
        <vxe-table-column  field="costPrice" :formatter="publicFmtnumber2" title="金额" width="80"></vxe-table-column>
        <vxe-table-column  field="costTax" :formatter="billTypeFmt" title="发票" width="80"></vxe-table-column>
        <vxe-table-column  field="contractCompany" :formatter="contractCompany" title="合同公司" width="80"></vxe-table-column>
        <vxe-table-column  field="amountPrice" :formatter="publicFmtnumber2" title="已开金额" width="80"></vxe-table-column>
        <vxe-table-column  field="receivedPrice" :formatter="publicFmtnumber2" title="已收金额" width="80"></vxe-table-column>
        <vxe-table-column  field="receiveable" :formatter="publicFmtnumber2" title="应收金额" width="80"></vxe-table-column>
        <vxe-table-column  field="guaTime"
                           :formatter="({row, column, cellValue, index}) => { return myFmtDateTime(cellValue,'MM/DD')}"
                           title="挂账日期" width="90" ></vxe-table-column>

      </vxe-table>
        <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="queryParams.pageSize"
        :current-page="queryParams.pageNum"
        @current-change="eventPage"
        style="text-align: right;padding: 10px 0px;background-color: #fff"
      >
      </el-pagination>
  </section>
</template>

<script>
  import {getDictionaryList} from "../../api/sysdictionary";
  import dayjs from "dayjs";
  import { ERR_OK } from "../../jslib/config";
  import {
    fmtDictionary,
  } from "../../jslib/util";
  import 'vxe-table/lib/style.css'
  import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx';
  import VXETable from 'vxe-table'
  import {getOtherCostStandingBook} from "../../api/otherCost";
  VXETable.use(VXETablePluginExportXLSX)

  export default {
    data(){
      return{
        value1:"",
        value2:"",
        tableData:[],
        tableLoading: false,
        queryParams: {
          pageNum : 1,
          pageSize: 20,
        },
        receiveTypelist:[
          {
            name:"开票",
            code:0
          },
          {
            name:"未开",
            code:1
          }
        ],
        total:0,
        toolbarButtons:[],
        wharfList:[],
        dictionaryLists:[],
      }
    },
    created() {
      this.$nextTick(() => {
        // 手动将表格和工具栏进行关联
        this.$refs.xTable.connect(this.$refs.xToolbar)
      })
      var getdic =getDictionaryList("other_income,bill_tax,contract_company");

      Promise.all([getdic]).then(values => {
        let res  = values[0];
        if (res != undefined && res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map;
        }
        this.getTableData(1)
      })
    },
    mounted(){
    },
    methods: {
      updatePageSie(){
        this.queryParams.pageSize = 5000
        this.getTableData(1)
      },
      returnPageSie(){
        this.queryParams.pageSize = 20
        this.getTableData(1)
      },
      getTableData(number){
        if(this.value1 != null && this.value1.length >0){
          this.queryParams.startTime =dayjs(this.value1[0]).format('YYYY-MM-DD HH:mm:ss')
          this.queryParams.endTime = dayjs(this.value1[1]).format("YYYY-MM-DD HH:mm:ss")
        } else {
          this.queryParams.startTime = null
          this.queryParams.endTime = null
        }
        if(this.value2 != null && this.value2.length >0){
          this.queryParams.startTime2 =dayjs(this.value2[0]).format('YYYY-MM-DD HH:mm:ss')
          this.queryParams.endTime2 = dayjs(this.value2[1]).format("YYYY-MM-DD HH:mm:ss")
        } else {
          this.queryParams.startTime2 = null
          this.queryParams.endTime2 = null
        }
        this.queryParams.pageNum = number
        this.tableLoading = true
        getOtherCostStandingBook(this.queryParams).then(res =>{
          this.tableData = res.list.rows
          this.total = res.list.total
          this.tableLoading = false
        })
      },
      publicFmt({row, column, cellValue, index}) {
        var v = "--";
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue
        }
        return v;
      },
      other_incomeFmt({row, column, cellValue, index}) {
        return fmtDictionary(cellValue, this.dictionaryLists["other_income"]);
      },
      myFmtDateTime(cellValue, fmtstr) {
        if (cellValue == undefined || cellValue == null || cellValue == "") {
          return "--";
        }
        return dayjs(cellValue).format(fmtstr);
      },
      publicFmtnumber2({row, column, cellValue, index}) {
        var v = 0;
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue.toFixed(2);

        }
        return v;
      },
      publicFmtnumber3({row, column, cellValue, index}) {
        var v = 0;
        if (cellValue != undefined && cellValue != null && cellValue != "") {
          v = cellValue.toFixed(3);

        }
        return v;
      },
      billTypeFmt({row,column,cellValue,index}){
        return fmtDictionary(cellValue,this.dictionaryLists['bill_tax']);
      },
      contractCompany({row, column, cellValue, index}) {
        return fmtDictionary(cellValue, this.dictionaryLists["contract_company"]);
      },
      eventPage(e){
        this.queryParams.pageNum = e;
        this.getTableData(e);
      },
    },
  }
</script>
<style scoped src="../../assets/css/mytable-scrollbar.css" ></style>
<style scoped>
  @import '../../assets/css/input.css';

  .bottom-btn{
    text-align: right;
    margin-top: 10px;
  }
  /* --------------------------------------------------------------- */
  .showTag{
    height: 120px;
  }
  .el-tag {
    cursor: pointer;
  }

  .choose-contract-type >>> .el-button {
    width: 120px;
  }

  .choose-contract-type >>> .el-form-item {
    margin-left: 1px;
    margin-right: 1px;
  }

  .contracrt-scrollbar {
    height: 100%;
    margin-bottom: 20px;
  }

  .show-contracts-image {
    display: flex;
    flex-wrap: wrap;
    width: 765px;
    height: 55vh;
    margin: 0 auto;
  }

  .show-contract-image {
    width: 220px;
    height: 340px;
    margin: 5px 15px;
    border-radius: 4px;
  }

  .show-contract-image >>> .contract-img {
    width: 210px;
    height: 297px;
    margin-top: 5px;
  }

  .show-contract-image >>> .yixuanze-img {
    width: 20px;
    height: 20px;
    border-radius: 60%;
    position: absolute;
    top: -5px;
    right: -5px;
    display: none;
  }

  .show-contract-image >>> p {
    color: #55575c;
    margin: 7px 0;
  }

  .chakan-img {
    display: none;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 40%;
    right: 40%;
  }

  .selected {
    background-color: #5992f5;
  }

  .selected >>> .yixuanze-img {
    display: block;
  }

  .selected >>> p {
    color: #ffffff;
  }

  .contract-iframe >>> p {
    position: absolute;
    left: 10px;
  }

  .contract-iframe >>> .el-button {
    position: absolute;
    right: 70px;
    margin-top: 10px;
  }

  /* ------------------------------------------------------------------------------------     */

  .hangci-biaoti-yupeizai {
    color: #409eff;
  }

  .hangci-biaoti {
    text-align: left;
    margin: 6px 0px;
  }

  .hangci-biaoti11 {
  }

  .hangci-biaoti12 {
    margin-left: 30px;
  }

  .hangci-biaoti1 {
    font-size: 0.8rem;
  }

  .hangci-biaoti2 {
    font-size: 0.8rem;
    margin-left: 20px;
  }

  .query-form {
    text-align: left;
    padding-top: 10px;
  }

  .sp_add_left {
    width: 45%;
    margin-right: 5%;
  }

  .sp_add_right {
    width: 45%;
  }

  .el-table-info >>> .cell {
    text-align: center;
  }

  .el-table-info >>> th {
    background: #f5f7fa;
  }

  .mytable td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .mytable td .cell {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }

  .el-table-info >>> .warning-cell {
    color: red;
  }

  .el-table-info >>> .success-cell {
    color: #6dd400;
  }

  .dialog-info {
    text-align: left;
    margin-top: -40px;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    display: inline-block;
  }

  .info-margin {
    margin-left: 5%;
    margin-right: 5%;
  }

  .info-title {
    display: inline-block;
    width: 5%;
    text-align: left;
  }

  .info-text {
    display: inline-block;
    width: 10%;
    text-align: left;
  }

  .myStep >>> .el-step__main {
    margin-top: 10px;
  }
  .hangci-biaoti2first {
    font-size: 0.8rem;
  }
  .hsbhs{
    margin-left: 20px;
  }
  .global-table-box>table {
    width: 100%;
    table-layout: fixed;
    border-spacing: 0;
    border-collapse: collapse\9;
  }

  .global-table thead td,
  .global-table th {
    line-height: 20px;
    font-size: 13px;
    padding: 15px 0;
    background-color: #F5F6FA;
    text-align: left;
    font-weight: bold;
    font-style: normal;
    margin: 0;
    color: #757b84;
    white-space: nowrap;
    border-bottom: 1px solid #EBEEF5;
  }
  .global-table tbody td {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #fff;
    color: #81858e;
    border-bottom: 1px solid #F5F4F5;
    font-size: 13px;
    height:30px;
    white-space: normal;
    word-break: break-all;
  }
  .global-table th {
    padding-left: 15px;
    padding-right: 5px;
  }

  .global-table tbody td.global-strong-td {
    font-weight: bold;
    color: #333;
    border-right: 1px solid #F5F4F5;
    background-color: #FAFBFD;
    padding: 0 20px;
  }

  .global-border-td {
    border-right: 1px solid #F5F4F5;
  }

  .global-table tbody td.globla-orange-td {
    color: #FF8446;
  }

  .global-table tr {
    cursor: default;
  }

  .global-table tr.selected td {
    background-color: #e0f0ff;
  }

  .global-table tr:nth-child(2n):not(.global-total-tr) td {
    background-color: #fbfbfb;
  }

  .global-table tr:hover td {
    background-color: #F5F8FF !important;
  }

  .global-table~.ui-loading {
    height: 300px;
  }

  .global-table .el-button--mini {
    font-size: 13px;
  }

  .global-table a {
    padding-right: 10px;
    font-size: 13px;
  }

  .global-table tbody tr.global-total-tr,
  .global-table tbody .global-total-tr td {
    font-size: 14px;
    font-weight: bold;
    color: #65696d;
  }

  .global-table tbody tr.global-subtotal-tr {
    font-weight: 500;
  }
  .el-input{
    width:100%;
  }
  myvxetable >>>.color1{
    background: #FAE8FF;
  }
  myvxetable >>>.color2{
    background-color: #CAEDFF;
  }
</style>

